import { Flex, Text } from "@chakra-ui/react";
import React from "react";

const DisplayData = ({ title, value, mt, align, fs, v_color, fw, w }) => {
  return (
    <Flex 
      gap={2} 
      marginTop={mt || 1} 
      align={align || "flex-start"}
      w="full"  // ✅ Add this
    >
      {title && (
        <Text
          flex={1}
          fontSize={"sm"}
          color={"#000"}
          fontWeight={"medium"}
          w={w}
          minW="150px"  // ✅ Add minimum width for consistency
        >
          {title}
        </Text>
      )}
      {title && (
        <Text 
          fontSize={"sm"} 
          color={"#000"} 
          fontWeight={"medium"}
          flexShrink={0}  // ✅ Prevent colon from shrinking
        >
          :
        </Text>
      )}
      {value && (
        <Text
          fontSize={fs || "14px"}
          color={v_color || "#000"}
          fontWeight={fw || "semibold"}
          flex={2.2}
          wordBreak="break-word"  // ✅ Handle long values
        >
          {value}
        </Text>
      )}
    </Flex>
  );
};

export default DisplayData;
